import React from 'react';
import { useLocation } from 'react-router-dom';
import Logo from './components/Logo';
import AlbumCover from './components/AlbumCover';
import PreSaveButton from './components/PreSaveButton';
import SongDetails from './components/SongDetails';
import './styles/app.css';
import { releaseConfig, getRemainingTime } from './config/releaseConfig';

function App() {
  const location = useLocation(); // Hook to get the current location

  const isSuccessPage = location.pathname === '/success'; // Check if the current URL is "/success"

  return (
    <div className="spotify-release-page">
      <Logo artist={releaseConfig.artist} />
      <div className="content-container">
        <AlbumCover imageSrc={releaseConfig.song.albumCover} />
        <SongDetails 
          title={releaseConfig.song.title}
          description={releaseConfig.song.description}
        />  
        {isSuccessPage ? (
          <div className="success-message">
            <p>Pre-Saved successfully.</p>
          </div>
        ) : (
          <PreSaveButton platform={releaseConfig.release.platform} />
        )}
        <div className="additional-info">
          <p className="release-countdown">{getRemainingTime(releaseConfig.release.date)}</p>
        </div>
      </div>
    </div>
  );
}

export default App;
